export default "__VITE_PUBLIC_ASSET__d5e65159__"